const areaMasterColumns = () => {
  return (
    [
      {
        Header: 'Display Sequence',
        accessor: 'displayseq',
        editType: 'Number',
        options: []
      },
      {
        Header: 'Area Id',
        accessor: 'areacode',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Name',
        accessor: 'areaname',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Description',
        accessor: 'areadesc',
        editType: 'inputField',
        options: []
      },

      {
        Header: 'Active ?',
        accessor: 'isactive',
        editType: 'Boolean',
        options: []
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
        editType: 'inputField',
        options: []
      }

    ]
  )
}

export default areaMasterColumns;
